import { SMALL_MODAL } from 'consts/modalStyles'

export const MODAL_STYLE = {
  ...SMALL_MODAL,
  content: {
    ...SMALL_MODAL.content,
    padding: '0px',
    width: '90%',
    maxWidth: 762,
  },
}

export const MODAL_REFRESH_DELAY = 10000
